/*
 *
 * ConfirmProfile reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_CONFIRMPROFILE,
  LOAD_CONFIRMPROFILE,
  LOAD_CONFIRMPROFILE_SUCCESS,
  LOAD_CONFIRMPROFILE_ERROR,
  CHANGE_CONFIRMPROFILE,
  CHANGE_CONFIRMPROFILE_SUCCESS,
  CHANGE_CONFIRMPROFILE_ERROR,
  DELETE_CONFIRMPROFILE,
  DELETE_CONFIRMPROFILE_SUCCESS,
  DELETE_CONFIRMPROFILE_ERROR,
} from './constants';

export const initialState = {
  loading: false,
  error: false,
  deleteSuccessful: false,
  confirmProfileList: false,
  confirmProfileData: false,
};

/* eslint-disable default-case, no-param-reassign */
const confirmProfileReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_CONFIRMPROFILE:
        return initialState;

      // LOAD
      case LOAD_CONFIRMPROFILE:
        draft.loading = true;
        draft.error = false;
        break;

      case LOAD_CONFIRMPROFILE_SUCCESS:
        draft.confirmProfileList = action.confirmProfileList;
        draft.loading = false;
        break;

      case LOAD_CONFIRMPROFILE_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // CHANGE/UPDATE
      case CHANGE_CONFIRMPROFILE:
        draft.confirmProfileData = {
          ...state.confirmProfileData,
          ...action.confirmProfileData,
        };
        draft.loading = true;
        draft.error = false;
        break;

      case CHANGE_CONFIRMPROFILE_SUCCESS:
        draft.loading = false;
        const { confirmProfileData } = action;
        draft.confirmProfileData = confirmProfileData;

        // update single item in the list inside state
        let listData = draft.confirmProfileList.data;
        let index = draft.confirmProfileList.data.findIndex(
          po => po._id === confirmProfileData._id,
        );
        index !== -1
          ? (listData[index] = confirmProfileData)
          : listData.unshift(confirmProfileData);
        draft.confirmProfileList = {
          ...draft.confirmProfileList,
          data: listData,
        };

        break;

      case CHANGE_CONFIRMPROFILE_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // DELETE
      case DELETE_CONFIRMPROFILE:
        draft.loading = true;
        draft.id = action.id;
        break;

      case DELETE_CONFIRMPROFILE_SUCCESS:
        draft.loading = false;
        draft.deleteSuccessful = true;
        break;
    }
  });

export default confirmProfileReducer;
